let worker;
const promises = [];
export function startWorker(mode_) {
    if (worker !== undefined)
        worker.terminate();
    const mode = mode_ ?? "2d";
    if (mode === "2d") {
        worker = new Worker(new URL("./worker-2d.ts", import.meta.url));
    }
    else if (mode === "webgl") {
        worker = new Worker(new URL("./worker-webgl.ts", import.meta.url));
    }
    else {
        throw new Error("Couldn't start worker");
    }
}
export function initialize(options) {
    const { textElem, canvasElem, overlayCanvas, turtleImage, turtleCenterX, turtleCenterY, } = options;
    const fps = options.fps ?? 30;
    const async = options.async ?? false;
    const { width, height } = canvasElem;
    const ctx = canvasElem.getContext("2d", {
        alpha: false,
    });
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, width, height);
    const turtleCtx = overlayCanvas.getContext("2d", {
        alpha: true,
    });
    if (worker === undefined) {
        throw new Error("Worker not started");
    }
    worker.onmessage = ({ data }) => {
        switch (data.type) {
            case "print":
                textElem.appendChild(document.createTextNode(data.text));
                break;
            case "clearText":
                textElem.replaceChildren();
                break;
            case "error": {
                let firstLine = data.message;
                if (data.procedureName) {
                    firstLine += ` in ${data.procedureName}`;
                }
                firstLine += "\n";
                const firstSpan = document.createElement("span");
                firstSpan.textContent = firstLine;
                firstSpan.style.color = "red";
                textElem.appendChild(firstSpan);
                if (data.line) {
                    const secondSpan = document.createElement("span");
                    secondSpan.textContent = `> ${data.line}\n`;
                    secondSpan.style.color = "red";
                    textElem.appendChild(secondSpan);
                }
                // promises[0].reject(firstLine);
                break;
            }
            case "draw":
                if (data.bitmap instanceof ImageBitmap) {
                    ctx.drawImage(data.bitmap, 0, 0);
                    data.bitmap.close();
                }
                if (data.bitmap instanceof ImageData) {
                    ctx.putImageData(data.bitmap, 0, 0);
                }
                turtleCtx.resetTransform();
                turtleCtx.clearRect(0, 0, width, height);
                if (data.turtle) {
                    const dx = width / 2 + data.turtle.x + 0.5;
                    const dy = height / 2 - data.turtle.y + 0.5;
                    turtleCtx.translate(dx, dy);
                    turtleCtx.rotate((data.turtle.heading * Math.PI) / 180);
                    turtleCtx.translate(-dx, -dy);
                    turtleCtx.drawImage(turtleImage, dx - turtleCenterX, dy - turtleCenterY);
                }
                break;
            case "finished": {
                const promise = promises.shift();
                promise.resolve();
                break;
            }
            case "prompt": {
                worker.postMessage({
                    type: "promptResult",
                    result: prompt(data.message),
                });
                break;
            }
        }
    };
    const left = -Math.floor(canvasElem.width / 2);
    const top = Math.floor(canvasElem.height / 2);
    const bottom = top - canvasElem.height + 1;
    const promise = Promise.withResolvers();
    promises.push(promise);
    worker.postMessage({
        type: "init",
        width: canvasElem.width,
        height: canvasElem.height,
        left,
        bottom,
        fps,
        async,
    });
    return promise.promise;
}
export function run(command) {
    if (!worker) {
        throw new Error("Not initialized");
    }
    const promise = Promise.withResolvers();
    promises.push(promise);
    worker.postMessage({
        type: "run",
        command,
    });
    return promise.promise;
}
